import { tenantService } from '../services/tenantService';

const apiUrl = import.meta.env.VITE_SIMPLE_REST_URL;

/**
 * Download a tenant-scoped API path with the same auth headers as the data provider.
 */
export async function downloadFileAuthenticated(pathOrUrl: string, filename?: string) {
  const url = pathOrUrl.startsWith('http')
    ? pathOrUrl
    : `${apiUrl}${pathOrUrl.startsWith('/') ? '' : '/'}${pathOrUrl}`;

  const token = localStorage.getItem('accessToken') || '';
  const headers: Record<string, string> = {
    Accept: 'application/pdf,application/octet-stream,*/*',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  try {
    const tenantCode = tenantService.getCurrentTenantCode();
    headers['x-tenant-code'] = tenantCode;
  } catch {
    throw new Error('No tenant selected. Please select a tenant to continue.');
  }

  const res = await fetch(url, { headers });
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(txt || `Failed to download (status ${res.status})`);
  }
  const blob = await res.blob();
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objectUrl;
  if (filename) a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(objectUrl), 10_000);
}
